import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import Quill from 'quill';
import MagicUrl from 'quill-magic-url';
import { Mention, MentionBlot } from 'quill-mention';
import { LocalStorageClass } from './helpers/local-storage-helper';
import { AnalyticsService } from './services/shared/analytics.service';
import { AppInitService } from './services/shared/app-init.service';
import { FirstTimeSetupDialog } from './ui/shared/first-time-setup-dialog/first-time-setup-dialog';
import { JenzConfirmationDialog } from './ui/shared/jenz-confirmation-dialog/jenz-confirmation-dialog';
import { Spinner } from './ui/shared/spinner/spinner';

Quill.register({
  'modules/mention': Mention,
  'blots/mention': MentionBlot,
  'modules/magicUrl': MagicUrl,
});

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true,
  imports: [RouterModule, Spinner, ToastModule, JenzConfirmationDialog, FirstTimeSetupDialog],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App implements OnInit {
  protected readonly title = signal('Jenz');

  private readonly initService = inject(AppInitService);

  constructor() {
    inject(AnalyticsService);
  }

  readonly setupCompleted = signal(LocalStorageClass.getTermsAndConditionsAccepted());

  ngOnInit(): void {
    this.initService.configureTranslateService();

    const token = LocalStorageClass.retrieveTokenFromStorage();

    if (token) {
      this.initService.initializeAppOnStartup();
    }
  }

  onSetupCompleted(): void {
    this.setupCompleted.set(true);
  }
}
